import(/* webpackMode: "eager" */ "/app/components/Breadcrumb.module.scss");
;
import(/* webpackMode: "eager" */ "/app/components/empty/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/formation/index.ts");
;
import(/* webpackMode: "eager" */ "/app/components/headToHead/Card/Card.module.scss");
;
import(/* webpackMode: "eager" */ "/app/components/headToHead/Card/CardHeader.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/Card/CtaLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/LineMovement/LineMovement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/LiveState/FollowButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/headToHead/LiveState/playByPlay.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/Overview/GameLog/OverviewGameLogDisplay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlayerDetails"] */ "/app/components/headToHead/Overview/injuries/InjuryBadge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/Overview/injuries/InjuryDisplay.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/headToHead/Overview/News/news.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/Overview/PlayerProps/FeaturedPlayerPropsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/Overview/popularBets/PopularBets.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/Overview/TeamStats/TeamStatsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/Overview/TeamStats/TeamStatsLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/PlayerStats/PlayerProps/PlayerProps.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/PlayerStats/PlayerStatsTable/PlayerStatsTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/PostGame/betSuccess/BetSuccessClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/headToHead/PostGame/betSuccess/betSuccessContainer.module.scss");
;
import(/* webpackMode: "eager" */ "/app/components/headToHead/PostGame/GameLeaders/gameLeaders.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/PostGame/GameLeaders/GameLeadersClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/headToHead/StateContainers/stateContainer.module.scss");
;
import(/* webpackMode: "eager" */ "/app/components/headToHead/Overview/fantasyProjections/topProjectedFantasy.module.scss");
;
import(/* webpackMode: "eager" */ "/app/components/headToHead/Overview/injuries/Injuries.module.scss");
;
import(/* webpackMode: "eager" */ "/app/components/headToHead/promotions/Promotions.module.scss");
;
import(/* webpackMode: "eager" */ "/app/components/headToHead/Overview/popularBets/popularBets.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/nfl/matchups/[...gameData]/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/Tabs/Tab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/Tabs/Tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/TeamContainer/TeamContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/TeamStats/DefensiveStats/DefensiveStats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/TeamStats/gameLog/GameLog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/TeamStats/TeamEfficiencyStats/TeamEfficiencyStats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/TeamStats/teamGameOdds/TeamGameOddsDisplay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/headToHead/TeamStats/TeamSuccessRateStats/TeamSuccessRateStats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/sport/FeaturedSport.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/Image.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/link/link.module.scss");
;
import(/* webpackMode: "eager" */ "/app/components/scoreboard/ScoreboardContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/sidebar/PromotionsWidget/Promotion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeadToHeadContextProvider"] */ "/app/utils/hooks/useHeadToHeadContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabContextProvider"] */ "/app/utils/hooks/useTabsContext.tsx");
